/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GuardarViajeSuscripcionResponse = {
  state: number;
  value: any;
};

export const guardarViajeSuscripcion = async (
  codViaje: number[] | undefined
): Promise<any> => {
  try {
    const res = await apiClient.post<GuardarViajeSuscripcionResponse>(
      Endpoints.GuardarViajeSuscripcion,
      { codViaje }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
